import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'fk-header',
    standalone: true,
    imports: [],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent { }
